export default [
    '711nl00000000001', '777nl00000000001', 'aventomga0000001-3', 'betcitynl0000001', 'betconstructnl01',
    'betnationnl00001', 'betssonnl0000001', 'krooncasinonl001', 'oranjecasinonl01', 'bingoalnl0000001',
    'boylesportsnl001', 'circusnl00000001', 'comeonnl00000001', 'entainnl00000001', 'fairplaycasinonl',
    'fairplaycasinonl-1', 'ggpokernl0000001', 'hollandcasinonl1', 'hommersonnl00001', 'icasinonl0000001',
    'interwettennl001', 'jacksnl000000001', 'betmgmnl00000001', 'leovegasnl000001', 'vibetnl000000001',
    'livescorenl00001', 'lnlnl00000000001', 'nlolivecasino001', 'onecasino0000001-4', 'playnorthnl00001',
    'kindrednl0000001', 'kindrednl0000001-1', 'mrvegas000000001-5', '888.nl', 'PRIMARY', 'leovegasnl000001-3',
    'livescorenloss01', '144', 'vivaro0000000001-2'
];
